import React, { useState } from "react";
import { logo } from "../../assets";
import axios from "../../library/axios";
import axiosLamApi from "../../library/axios-lam-api";
import { MySwal } from "../../library/swal";
import { FormVerificationManual } from "../../components";
import Modal from "react-bootstrap/Modal";
import { IconRocket } from "@tabler/icons-react";
import { setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";

const VerificationPage = () => {
  const [kodeVerifikasi, setkodeVerifikasi] = useState("");
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showVerificationManual, setshowVerificationManual] = useState(false);

  const handleSubmit = () => {
    if (kodeVerifikasi.length === 0) {
      MySwal.fire({
        icon: "error",
        title: "Oops, Validasi Gagal !",
        text: "Kode Verifikasi tidak boleh kosong.",
      });
      return false;
    }

    setLoading(true);
    setDisabled(true);

    // fe post ke be untuk kode verifikasi
    const requestBody = {
      kodeVerifikasi: kodeVerifikasi,
    };

    axiosLamApi({
      url: "/auth/verifikasi",
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: requestBody,
    })
      .then((res) => {
        // console.log(res.data);
        // return false;
        if (res?.data?.code === 200) {
          // insert new user to table users with role Administrator
          // insert maping group for administrator
          handleStepFirst();

          // insert data m_rumah_sakit ke table profile
          handleInsertProfile(res.data.record);
        } else {
          MySwal.fire({
            icon: "error",
            title: "Oops, Validasi Gagal",
            text: `${res?.data?.message}`,
          });
          setLoading(false);
          setDisabled(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);

        if (err !== "") {
          console.log(err.message);

          MySwal.fire({
            icon: "error",
            title: "Bad Request!",
            text: "Parameter tidak lengkap.",
          });
        }
      });
  };

  const handleStepFirst = async () => {
    try {
      const options = {
        url: `/users/stepFirst`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleInsertProfile = (object) => {
    const requestBody = {
      namaRs: object.Nama,
      kodeRs: object.KodeRs,
      direktur: object.Direktur,
      alamat: object.Alamat,
      telp: object.Telp,
      website: object.Website,
      email: object.emailRs,
    };

    // console.log(requestBody)
    // return false

    axios({
      url: "/profile/create",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res)
        if (res.status === 200) {
          // insert data m_staff ke contact_person
          handleInsertContactPerson(res.data.id, object);
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err.message);
        }
      });
  };

  const handleInsertContactPerson = (idProfile, object) => {
    // console.log(object[0].NamaDepan)
    // return false

    const requestBody = {
      idProfile: idProfile,
      namaDepan: object.NamaDepan,
      namaBelakang: object.NamaBelakang,
      namaPanggilan: object.NamaPanggilan,
      email: object.EmailPic,
      hp1: object.Hp1,
      hp2: object.Hp2,
      gender: object.Gender === "P" ? "Pria" : "Wanita",
    };

    // console.log(requestBody)

    axios({
      url: "/contact-person/create-contact-person",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res)
        if (res.status === 200) {
          handleLogin("sa", "Qwerty123#");
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err.message);
        }
      });
  };

  const handleLogin = (username, password) => {
    const requestBody = {
      username: username,
      password: password,
    };

    axios({
      url: "/users/auth",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Validasi Sukses, Mohon Tunggu",
            text: "Anda akan di arahkan ke halaman Profile!",
          });

          setTimeout(() => {
            // get token from the result
            localStorage.setItem(`token${getSlug() ? '-' + getSlug() : ''}`, res?.data?.token);
            
            // Determine redirect path based on user role
            const groupName = res?.data?.groupName || "";
            let redirectPath = "/profile"; // default redirect
            
            if (groupName === "Kelompok Kerja") {
              redirectPath = "/dashboard-pokja";
            } else if (groupName === "Surveior Internal") {
              redirectPath = "/dashboard-internal";
            } else if (groupName === "Surveior External") {
              redirectPath = "/accreditation";
            }
            
            setHrefWithSlugHook(redirectPath);
          }, 3000);

          setLoading(false);
          setDisabled(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err.message);
        }
      });
  };

  return (
    <>
      {/*begin::Main*/}
      <div className="d-flex flex-column flex-root" style={{ marginTop: "3%" }}>
        {/*begin::Authentication - Password reset */}
        <div
          className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
        // style={{
        //   backgroundImage:
        //     "url(metronic/dist/assets/media/illustrations/dozzy-1/14.png",
        // }}
        >
          {/*begin::Content*/}
          <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-10">
            {/*begin::Logo*/}
            <a className="mb-10">
              <img alt="Logo" src={logo} className="h-60px" />
            </a>
            {/*end::Logo*/}
            {/*begin::Wrapper*/}
            <div className="bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
              <div className="card">
                <h3 className="card-title text-info">
                  *Form Verifikasi #SPEAK_HOSPITAL
                </h3>
                <div className="card-header card-header-stretch">
                  <div className="card-toolbar">
                    <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          href="#kt_tab_pane_7"
                        >
                          Metode Online
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#kt_tab_pane_8"
                        >
                          Metode Offline
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card-body">
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="kt_tab_pane_7"
                      role="tabpanel"
                    >
                      {/*begin::Form*/}
                      <form
                        className="form w-100"
                        noValidate="novalidate"
                        id="kt_password_reset_form"
                      >
                        {/*begin::Heading*/}
                        <div className="mb-5">
                          {/*begin::Link*/}
                          <div className="fw-bold fs-5">
                            Sebelum munggunakan #SPEAK_HOSPITAL silahkan submit
                            <br></br>
                            Kode Verifikasi yang sudah kami kirimkan ke email
                            terdaftar.
                            <br></br>
                            <b style={{ color: "#E74C3C" }}>
                              Metode ini membutuhkan koneksi internet yang
                              stabil.
                            </b>
                            <br></br>
                            Untuk proses sinkronisasi data dari Server kami.
                          </div>
                          {/*end::Link*/}
                        </div>
                        {/*begin::Heading*/}
                        {/*begin::Input group*/}
                        <div className="fv-row mb-5">
                          <label className="form-label fw-bolder text-gray-900 fs-6">
                            Kode Verifikasi
                          </label>
                          <input
                            className="form-control form-control-solid"
                            type="text"
                            autoComplete="off"
                            onChange={(e) => setkodeVerifikasi(e.target.value)}
                            value={kodeVerifikasi}
                            placeholder="******"
                          />
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Actions*/}
                        <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                          <button
                            onClick={() => handleSubmit()}
                            type="button"
                            className="btn btn-lg btn-primary fw-bolder me-4"
                          >
                            <span
                              className="indicator-label"
                              disabled={disabled}
                            >
                              <IconRocket stroke={2} />{" "}
                              {loading === true ? "Mohon Tunggu.." : "Submit"}
                            </span>
                          </button>
                        </div>
                        {/*end::Actions*/}
                      </form>
                      {/*end::Form*/}
                    </div>
                    <div
                      className="tab-pane fade"
                      id="kt_tab_pane_8"
                      role="tabpanel"
                    >
                      <div className="fw-bold fs-5">
                        Metode Offline ini mengharuskan anda mengisi data
                        <br></br>
                        Profil Rumah Sakit & Narahubung secara Manual.
                        <br></br>
                        <b style={{ color: "#E74C3C" }}>
                          Metode ini tidak membutuhkan koneksi Internet.
                        </b>
                        <br></br>
                        Klik tombol di bawah ini untuk melanjutkan.
                        <br></br>
                        <div className="row justify-content-center mt-5">
                          <button
                            onClick={() => setshowVerificationManual(true)}
                            type="button"
                            className="btn btn-light-primary "
                          >
                            <IconRocket stroke={2} /> Lanjutkan
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*end::Wrapper*/}
          </div>
          {/*end::Content*/}
          {/*begin::Footer*/}
          <div className="d-flex flex-center flex-column-auto">
            {/*begin::Links*/}
            <div className="d-flex align-items-center fw-bold fs-6">
              {/* <a href="https://lam-kprs.id/" target='_blank' className="text-muted text-hover-primary px-2">2023© | LAM-KPRS</a> */}
              <small>APP Version: 0.4.64</small>
            </div>
            {/*end::Links*/}
          </div>
          {/*end::Footer*/}
        </div>
        {/*end::Authentication - Password reset*/}
      </div>
      {/*end::Main*/}
      <Modal
        show={showVerificationManual}
        onHide={() => setshowVerificationManual(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Form Profil RS & Narahubung</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormVerificationManual
            close={() => setshowVerificationManual(false)}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VerificationPage;
